import React from 'react';

export const SvgFallbackLogo = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="6" fill="#E7F0FF" />
      <path
        d="M27 17.75C27 18.91 26.12 19.85 25 19.97V24C25 24.55 24.55 25 24 25H20.25C20.25 24.03 19.47 23.25 18.5 23.25C17.53 23.25 16.75 24.03 16.75 25H12C11.45 25 11 24.55 11 24V19.25C11.97 19.25 12.75 18.47 12.75 17.5C12.75 16.53 11.97 15.75 11 15.75V12C11 11.45 11.45 11 12 11H16.03C16.16 9.88 17.1 9 18.25 9C19.4 9 20.35 9.88 20.47 11H24C24.55 11 25 11.45 25 12V15.53C26.12 15.66 27 16.6 27 17.75Z"
        fill="#A8CAFF"
      />
    </svg>
  );
};
